'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$107() {
  this.bcU = null;
  this.bcV = false;
}
export { $c_Lpresto_PrestoRouter$$anon$107 as $c_Lpresto_PrestoRouter$$anon$107 };
$p = $c_Lpresto_PrestoRouter$$anon$107.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$107;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$107() {
}
export { $h_Lpresto_PrestoRouter$$anon$107 as $h_Lpresto_PrestoRouter$$anon$107 };
$h_Lpresto_PrestoRouter$$anon$107.prototype = $p;
$p.P = (function() {
  if ((!this.bcV)) {
    this.bcU = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T1($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$());
    this.bcV = true;
  }
  return this.bcU;
});
var $d_Lpresto_PrestoRouter$$anon$107 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$107, "presto.PrestoRouter$$anon$107", ({
  NE: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$107 as $d_Lpresto_PrestoRouter$$anon$107 };
//# sourceMappingURL=presto.-Presto-Router$$anon$107.js.map
